<template>
    <div class="ProfileSubordinate" v-if="lang">
        <div class="table table--profiles">
            <h2 style="margin: 0 0 1em 0" class="section--title">{{translate.pages.role_profiles.index.title}}</h2>
            <md-button v-if="addButton" class="md-icon-button md-raised button" @click.native="openDialog('addProfile')">
                <md-icon>add</md-icon>
            </md-button>
            <md-button v-else class="md-icon-button md-raised button-remove" @click.native="removeRoles">
                <md-icon>clear</md-icon>
            </md-button>
            <md-table-card class="table--wrap">
                <md-table md-sort="name" @sort="onSort" md-sort-by="name">
                    <md-table-header>
                        <md-table-row>
                            <md-table-head class="td-sort-name" md-sort-by="name">{{translate.pages.role_profiles.index.fields.name}}</md-table-head>
                            <md-table-head class="text-right">{{translate.pages.role_profiles.index.fields.actions}}</md-table-head>
                        </md-table-row>
                    </md-table-header>
                    <md-table-body>
                        <md-table-row v-for="(row, rowIndex) in roles" :key="rowIndex" :md-item="row">
                            <md-table-cell>
                                <span class="name">{{ row.display_name }}</span>
                            </md-table-cell>
                            <td class="md-table-cell actions md-has-action">
                                <div class="md-table-cell-container">
                                    <md-icon class="icon-edit raised" @click.native="openDialog('edit', row, rowIndex)">edit</md-icon>
                                    <md-icon class="icon-delete raised" @click.native="remove(row, rowIndex)">delete</md-icon>
                                </div>
                            </td>
                        </md-table-row>
                        <md-table-row v-if="roles.length == 0">
                            <md-table-cell colspan="2">
                                {{translate.pages.role_profiles.index.no_records}}
                            </md-table-cell>
                        </md-table-row>
                    </md-table-body>
                </md-table>
            </md-table-card>
            <md-dialog md-open-from="#custom" md-close-to="#custom" ref="addProfile"
                :md-click-outside-to-close="close"
                :md-esc-to-close="close">
                <md-dialog-content>
                    <h3 class="dialog--title">{{translate.pages.role_profiles.add.title}}</h3>
                    <hr>
                    <div class="content-main">
                        <md-layout md-gutter class="modal-wrap">
                        <md-layout md-flex="100" class="container">
                            <md-input-container>
                                <label for="profile_suggestion">Sugerencia de Nombre:</label>
                                <md-select id="profile_suggestion" v-model="newProfile.sname" @change="setSuggestionName(newProfile.sname)">
                                    <md-option  value="Prestador">Prestador</md-option>
                                    <md-option  value="Asistente">Asistente</md-option>
                                    <md-option  value="Secretaria">Secretaria/o</md-option>

                                </md-select>
                            </md-input-container>
                        </md-layout>

                            <md-layout md-flex="100" class="container">
                                <md-input-container :class="{ 'md-input-invalid' : errors.name.invalid }">
                                    <label>{{translate.pages.role_profiles.add.fields.name}}</label>
                                    <md-input type="text" v-model="newProfile.name"></md-input>
                                    <span class="md-error" v-if="errors.name.invalid">{{ errors.name.msg }}</span>
                                </md-input-container>
                            </md-layout>
                            <md-layout md-flex="100" class="container">
                                <md-layout md-flex-xsmall="100" md-flex="50">
                                    <p class="title">{{translate.pages.role_profiles.add.fields.permissions}}</p>
                                </md-layout>
                                <md-layout md-flex-xsmall="100" md-flex="50" class="selectAll" @click.native="selectAll">
                                    <p>{{translate.pages.role_profiles.add.fields.select_all}}</p>
                                </md-layout>
                                <md-layout md-flex="100" class="container">
                                    <div class="multiple checkbox-list">
                                        <div class="select">
                                            <div v-for="(menu,index) in group_menu" :key="index">
                                                <label>{{ menu.name }}</label>
                                                <md-checkbox class="option" v-for="permission in menu.perms" :key="permission.id" @change="onChosen($event,permission.id)" v-model="permission.checked">{{ permission.display_name }}</md-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </md-layout>
                                <label class="subtitle" :class="{ error: errors.group_menu.invalid }">{{translate.pages.role_profiles.add.fields.select_permissions_profile}}</label>
                            </md-layout>
                        </md-layout>
                    </div>
                </md-dialog-content>
                <md-dialog-actions class="modal--footer">
                    <md-button style="padding: 0 15px !important;" class="float-l md-primary md-size sm-size btn--cancel" @click.native="closeDialog('addProfile')">{{translate.actions.cancel}}</md-button>
                    <md-button style="padding: 0 15px !important;" class="float-r md-primary md-size sm-size btn--blue" @click.native="closeDialog('addProfile', true)" :disabled="process">Agregar</md-button>
                </md-dialog-actions>
            </md-dialog>
            <md-dialog md-open-from="#custom" md-close-to="#custom" ref="edit"
                :md-click-outside-to-close="close"
                :md-esc-to-close="close">
                <md-dialog-content>
                    <h3 class="dialog--title">{{translate.pages.role_profiles.edit.title}}</h3>
                    <hr>
                    <div class="content-main">
                        <md-layout md-gutter class="modal-wrap">
                            <md-layout md-flex="100" class="container">
                                <md-input-container :class="{ 'md-input-invalid' : errors.name.invalid }">
                                    <label>{{translate.pages.role_profiles.edit.fields.name}}</label>
                                    <md-input type="text" v-model="currentProfile.display_name"></md-input>
                                    <span class="md-error" v-if="errors.name.invalid">{{ errors.name.msg }}</span>
                                </md-input-container>
                            </md-layout>
                            <md-layout md-flex="100" class="container">
                                <md-layout md-flex-xsmall="100" md-flex="50">
                                    <p class="title">{{translate.pages.role_profiles.edit.fields.permissions}}</p>
                                </md-layout>
                                <md-layout md-flex-xsmall="100" md-flex="50" class="selectAll" @click.native="selectAll">
                                    <p>{{translate.pages.role_profiles.edit.fields.select_all}}</p>
                                </md-layout>
                                <md-layout md-flex="100" class="container">
                                    <div class="multiple checkbox-list">
                                        <div class="select">
                                            <div v-for="(menu,index) in group_menu" :key="index">
                                                <label>{{ menu.name }}</label>
                                                <md-checkbox class="option" v-for="permission in menu.perms" :key="permission.id" @change="onChosen($event,permission.id,true)" v-model="permission.checked">{{ permission.display_name }}</md-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </md-layout>
                                <label class="subtitle" :class="{ error: errors.group_menu.invalid }">{{translate.pages.role_profiles.edit.fields.select_permissions_profile}}</label>
                            </md-layout>
                        </md-layout>
                    </div>
                </md-dialog-content>
                <md-dialog-actions class="modal--footer">
                    <md-button style="padding: 0 5px !important;" class="md-primary btn--cancel" @click.native="closeDialog('edit')">{{translate.actions.cancel}}</md-button>
                    <md-button style="padding: 0 5px !important;" class="md-primary btn--blue" @click.native="closeDialog('edit', true)" :disabled="process">Guardar</md-button>
                </md-dialog-actions>
            </md-dialog>
        </div>
    </div>
</template>
<script>
    import { doctor } from '../../../config/api.js';
    const swal = require('sweetalert2');
    export default {
        data: () => ({
            process: false,
            roles: [],
            group_menu: [],
            addButton: true,
            errors: {
                name: {
                    invalid: false,
                    msg: ''
                },
                group_menu: {
                    invalid: false,
                    msg: ''
                }
            },
            newProfile: {
                name: '',
                sname: '',
                perms: []
            },
            currentProfile: {
                name: '',
                perms: []
            },
            close: false,
            currentIndex: -1
        }),
        created() {
            // Get roles
            this.$http.get(doctor.api.roles,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    this.roles = data.roles;
                    this.group_menu = data.group_menu;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
        },
        computed: {
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Set suggetion Name
            setSuggestionName(suggestion) {
                console.log(suggestion)
                this.newProfile.name = suggestion
            },
            // Sort roles
            onSort(sort) {
                this.roles = _.orderBy(this.roles, [item => item[sort.name]], sort.type);
            },
            // Open Modal
            openDialog(ref, row, rowIndex) {
                if(row)
                {
                    this.currentIndex = rowIndex;
                    this.currentProfile = JSON.parse(JSON.stringify(row));
                    this.currentProfile.perms.forEach( (permission) => {
                        this.group_menu.forEach( row =>{
                            row.perms.forEach( _row => {
                                if(permission.id == _row.id)
                                {
                                    _row.checked = true;
                                }
                            });
                        });
                    });
                }
                this.$refs[ref].open();
            },
            // Close modal
            closeDialog(ref, save) {
                if(save)
                {
                    if(ref == 'edit')
                    {
                        this.update(ref);
                    }else{
                        this.save(ref);
                    }
                }else{
                    this.removeSelect();
                    this.$refs[ref].close();
                }
            },
            // On chosen by permission
            onChosen(add, permission_id, update){
                if(add){
                    if(update){
                        this.currentProfile.perms.push({"id": permission_id});
                    }else{
                        this.newProfile.perms.push({"id": permission_id});
                    }
                }else{
                    if(update){
                        this.currentProfile.perms.find( (permission, index) => {
                            if(permission)
                            {
                                if (permission.id == permission_id){
                                    this.currentProfile.perms.splice(index,1);
                                    return false;
                                }
                            }
                        });
                    }else{
                        this.newProfile.perms.find( (permission, index) => {
                            if (permission.id == permission_id){
                                this.newProfile.perms.splice(index,1);
                                return false;
                            }
                        });
                    }
                }
            },
            selectAll(){
                console.log("obj");
                /*this.group_menu.forEach(group => {
                    group.perms.forEach(permission => {
                        permission.checked = true;
                    });
                });*/
            },
            // Store profile
            save(ref){
                let error = false;
                if(this.newProfile.name.length == 0)
                {
                    this.errors.name.invalid = true;
                    this.errors.name.msg = this.translate.pages.subordinates.profile.add.validations.name;
                    error = true;
                }else{
                    this.errors.name.invalid = false;
                    this.errors.name.msg = "";
                }
                if(this.newProfile.perms.length == 0)
                {
                    this.errors.group_menu.invalid = true;
                    this.errors.group_menu.msg = this.translate.pages.subordinates.profile.add.validations.group_menu;
                    error = true;
                }else{
                    this.errors.group_menu.invalid = false;
                    this.errors.group_menu.msg = "";
                }
                if(error){
                    return false;
                }
                this.process = true;
                this.$http.post(doctor.api.roles, this.newProfile,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    this.process = false;
                    let data = response.data.data;
                    this.roles.push(data);
                    this.newProfile = {
                        name: '',
                        perms: []
                    };
                    this.$refs[ref].close();
                    swal('', response.data.msg, 'success');
                }).catch(error => {
                    this.process = false;
                    console.log(error);
                    if(error.response.status === 401){
                        if(error.response.data.msg.max_profiles)
                        {
                            swal(this.translate.pages.office.add.title, error.response.data.msg.max_profiles, 'warning');
                        }
                    }
                    //alert("No se pudo cargar las comunidades");
                });
            },
            // Update profile
            update(ref){
                let error = false;
                if(this.currentProfile.display_name.length == 0)
                {
                    this.errors.name.invalid = true;
                    this.errors.name.msg = this.translate.pages.subordinates.profile.edit.validations.name;
                    error = true;
                }else{
                    this.errors.name.invalid = false;
                    this.errors.name.msg = "";
                }
                if(this.currentProfile.perms.length == 0)
                {
                    this.errors.group_menu.invalid = true;
                    this.errors.group_menu.msg = this.translate.pages.subordinates.profile.edit.validations.group_menu;
                    error = true;
                }else{
                    this.errors.group_menu.invalid = false;
                    this.errors.group_menu.msg = "";
                }
                if(error){
                    return false;
                }
                this.process = true;
                this.$http.put(doctor.api.roles + '/' + this.currentProfile.id, {
                            'display_name' : this.currentProfile.display_name,
                            'perms': this.currentProfile.perms
                    },
                    {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    this.process = false;
                    let data = response.data.data;
                    this.roles[this.currentIndex] = data;
                    this.currentProfile = {
                        name: '',
                        perms: []
                    };
                    this.currentIndex = -1;
                    this.removeSelect();
                    this.$refs[ref].close();
                    swal('', response.data.msg, 'success');
                }).catch(error => {
                    console.log(error);
                    this.process = false;
                    //alert("No se pudo cargar las comunidades");
                });
            },
            // Remove profile
            remove(row, rowIndex){
                swal(this.translate.pages.subordinates.profile.swal_remove.title, this.translate.pages.subordinates.profile.swal_remove.message, 'warning')
                    .then( () => {
                        this.$http.delete(doctor.api.roles + '/' + row.id,{
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                let data = response.data.data;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.roles.splice(rowIndex, 1);
                                    }, (dismiss) => {
                                        this.roles.splice(rowIndex, 1);
                                    });
                            }).catch(error => {
                                console.log(error);
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Remove select
            removeSelect(){
                this.group_menu.forEach( row => {
                    row.perms.forEach( _row => {
                        _row.checked = false;
                    });
                });
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    .ProfileSubordinate
        .table
            padding 3em 2em 2em 2em
            position relative
            .text-center
                text-align center
            .text-right
                text-align right
            .icon-detail
                color color_form_value
                opacity 0.8
                &:hover
                    color color_form_value
                    opacity 1
                    text-decoration none
            .button
                background-color color_main
                color white
                position absolute
                right 1.5em
                top 2em
                z-index 5
                &:hover
                    background-color color_main
                    color white
            .button-remove
                background-color color_error
                color white
                position absolute
                right 1.5em
                top 4em
                z-index 100
                &:hover
                    background-color color_error
                    color white
            .actions
                div
                    display block
                    text-align right
                .icon-edit
                    color color_notifications
                    cursor pointer
                    font-size 22px
                .icon-delete
                    color color_error
                    cursor pointer
                    font-size 22px
    .multiple
        border 1px solid color_form_border
        border-radius 5px
        width 100%
        .title
            margin 0.5em
            color color_form_placeholder
        .select
            overflow-y scroll
            overflow-x hidden
            margin 0.25em
            height 210px
            .option
                width 95%
                margin 0.25em
    .subtitle
        margin-top .5em
        color color_form_placeholder
        &.error
            color color_error
    .selectAll
        color color_main
        justify-content flex-end
        text-align right
        text-transform uppercase
        p
            cursor pointer
    @import '../../../assets/styles/responsive.styl'
</style>
<style>
    .btn--cancel {
        color: #ff0000b3 !important;
    }
</style>



// WEBPACK FOOTER //
// Profile.vue?a1af38f8